import { useState } from 'react';
import { Button } from './styled';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
import { AUTH_API } from '../../../../../api/amplify';
import { wait } from '../../../../../utils/commonHelpers';

export const GoogleSigninButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const onGoogleSignin = async () => {
    try {
      if (window.ymGlobal) {
        window.ymGlobal(90338500, 'reachGoal', 'google_sign_in');
      }

      setIsLoading(true);
      await wait(1000);
      await AUTH_API.socialSignIn(CognitoHostedUIIdentityProvider.Google);
    } catch (e) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <Button isLoading={isLoading} onClick={onGoogleSignin}>
      Войти через Google
    </Button>
  );
};
